<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div
    *ngIf="executiveAssociateEmailAudits && executiveAssociateEmailAudits.length > 0; else noAudits"
  >
    <sd-portal-audit-detail-list [audits]="executiveAssociateEmailAudits" (nextPage)="onNextPage()">
    </sd-portal-audit-detail-list>
  </div>

  <ng-template #noAudits> No Executive Admin Email audits </ng-template>
</ng-template>
